import request from '@/plugins/axios'
import systemConfig from '@/plugins/requireConfig/systemConfig.js'


// 查询日志分页
export function logPage(data) {
    return request({
        url: `/${systemConfig.sysPrefix}/sys/log/page`,
        method: 'post',
        data: data
    })
}

// 查询日志列表
export function logList(data) {
    return request({
        url: `/${systemConfig.sysPrefix}/sys/log/list`,
        method: 'post',
        data: data
    })
}

// 查询日志详细
export function logDetail(id) {
    const data = {
        id : id
    };
    return request({
        url: `/${systemConfig.sysPrefix}/sys/log/detail`,
        method: 'post',
        data
    })
}
